const state = {
  all: [],
  loading: false,
  loadingList: [],
}

export const getters = {
  forOpportunity: state => id => {
    return state.all.find(eligibility => eligibility.opportunityId === id)
  },
  inLoadingList: state => opportunityId => state.loadingList.indexOf(opportunityId) >= 0,
}

export const mutations = {
  setAll(state, eligibilities) {
    const freshSet = JSON.parse(JSON.stringify(eligibilities))
    freshSet.forEach(eligibility => {
      const index = state.all.findIndex(e => e.id == eligibility.id)
      // if (index >= 0) state.all.splice(index, 1, { ...e, ...eligibility })
      if (index < 0) state.all.push(eligibility)
    })
    state.loading = false
  },

  set(state, eligibility) {
    const index = state.all.findIndex(e => e.id == eligibility.id)
    if (index >= 0) state.all.splice(index, 1, eligibility)
    if (index < 0) state.all.push(eligibility)
  },

  addToLoadingList(state, opportunityId) {
    const found = state.loadingList.indexOf(opportunityId) >= 0
    if (!found) state.loadingList.push(opportunityId)
  },

  removeFromLoadingList(state, opportunityId) {
    state.loadingList = state.loadingList.filter(i => i !== opportunityId)
  },
}

export const actions = {
  fetchAll({ state, commit }) {
    state.loading = true
    return api.getEligibilities().then(
      ({ data }) => commit('setAll', data),
      ({ errors }) => {
        state.loading = false
        return errors
      }
    )
  },

  checkEligibility({ commit, getters }, opportunity) {
    if (!opportunity || getters.inLoadingList(opportunity.id)) return
    commit('addToLoadingList', opportunity.id)
    return api
      .getEligibility(opportunity)
      .then(response => {
        commit('set', response.data)
        return response
      })
      .finally(() => commit('removeFromLoadingList', opportunity.id))
  },
}

export const api = {
  getEligibilities: () => Vue.$http.get('candidate/eligibilities'),
  getEligibility: opportunity => {
    return Vue.$http.get(`candidate/opportunities/${opportunity.id}/eligibility`)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
